
import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';
import { Link } from 'react-router-dom';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="pt-40 pb-32 px-6 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="font-['Fraunces'] text-4xl md:text-5xl font-bold text-[#1A2A2A] mb-4">
            Get in Touch
          </h1>
          <p className="text-lg text-[#505A5A] mb-16 max-w-xl mx-auto">
            Choose how you&apos;d like to reach us. We&apos;re happy to help with any questions about short-term rental compliance and management.
          </p>

          <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto">
            {/* Email Option */}
            <a
              href="mailto:contact@furnishedrentalmanagement.com"
              className="group bg-[#F9F5F0] rounded-2xl p-10 flex flex-col items-center text-center hover:shadow-lg transition-all duration-300 cursor-pointer border border-transparent hover:border-[#882629]/20"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#882629]/10 mb-6 group-hover:bg-[#882629]/20 transition-colors">
                <i className="ri-mail-line text-3xl text-[#882629]"></i>
              </div>
              <h2 className="font-['Fraunces'] text-xl font-semibold text-[#1A2A2A] mb-2">
                Send Us an Email
              </h2>
              <p className="text-sm text-[#505A5A] mb-6 leading-relaxed">
                Have a detailed question or prefer writing? Drop us an email and we&apos;ll get back to you within 24 hours.
              </p>
              <span className="inline-flex items-center gap-2 text-[#882629] font-semibold text-sm group-hover:gap-3 transition-all whitespace-nowrap">
                contact@furnishedrentalmanagement.com
                <i className="ri-arrow-right-line text-base"></i>
              </span>
            </a>

            {/* Phone / Book a Call Option */}
            <Link
              to="/book-call"
              className="group bg-[#F9F5F0] rounded-2xl p-10 flex flex-col items-center text-center hover:shadow-lg transition-all duration-300 cursor-pointer border border-transparent hover:border-[#882629]/20"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#882629]/10 mb-6 group-hover:bg-[#882629]/20 transition-colors">
                <i className="ri-phone-line text-3xl text-[#882629]"></i>
              </div>
              <h2 className="font-['Fraunces'] text-xl font-semibold text-[#1A2A2A] mb-2">
                Book a Free Intro Call
              </h2>
              <p className="text-sm text-[#505A5A] mb-6 leading-relaxed">
                Prefer to talk it through? Schedule a free call and we&apos;ll walk you through your options live.
              </p>
              <span className="inline-flex items-center gap-2 text-[#882629] font-semibold text-sm group-hover:gap-3 transition-all whitespace-nowrap">
                Schedule a Call
                <i className="ri-arrow-right-line text-base"></i>
              </span>
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
